import { City, Town } from '../types/address';
import { Category } from '../types/categories';
import { ImageType } from '../types/files';
import { ApiRepository } from './base_repository';
import { FeedbackToastHandler } from '../../config/errors/feedback';
import { sharedAxiosInstance } from '../../utils/axios/axios';
import { Listing } from '../../data/types/listings';
import { API_BASE } from '../../config/constants';

export type SilalImagesResponse = {
  images: ImageType[];
  total: number;
  page: number;
  pages: number;
  per_page: number;
  http_status: number;
};

class SharedApiRepository extends ApiRepository {
  private static instance: SharedApiRepository | null = null;
  constructor(axiosInstance: any) {
    super(axiosInstance);
  }

  public static getInstance(axiosInstance: any): SharedApiRepository {
    if (!SharedApiRepository.instance) {
      SharedApiRepository.instance = new SharedApiRepository(axiosInstance);
    }
    return SharedApiRepository.instance;
  }

  getCategoriesAsList = async () => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest('GET', `/categories/list/`),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
          noPendingMsg: true,
        },
      );

      return res.data.categories as Category[];
    } catch (error: any) {
      return false;
    }
  };

  getCategoryBrief = async (
    category_id: number,
    with_official_values: boolean = false,
  ) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest(
          'GET',
          `/categories/brief/${category_id}/${with_official_values ? '?with_official_values=true' : ''}`,
        ),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
          noPendingMsg: true,
        },
      );
      return res.data.resource as Category;
    } catch (error: any) {
      return false;
    }
  };

  getCategoryDetails = async (
    category_id: number,
    with_official_values: boolean = true,
  ) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest(
          'GET',
          `/categories/${category_id}/${
            with_official_values ? '?with_official_values=true' : ''
          }`,
        ),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
          noPendingMsg: true,
        },
      );

      return res.data.resource as Category;
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };

  getOfficialValuesOfAttributes = async (attributes_ids: number[]) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest('PUT', `/attributes/get_select_attrs_values/`, {
          baseApiUrl: API_BASE,
          data: {
            attributes_ids: attributes_ids,
          },
        }),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
          noPendingMsg: true,
        },
      );

      return res.data.attributes as any;
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };

  getCities = async (regionId: number | string) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest('GET', `/region/${regionId}/cities/`),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
          noPendingMsg: true,
        },
      );
      return res.data.result as City[];
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };

  getTowns = async (cityId: number | string) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest('GET', `/city/${cityId}/towns/`),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
          noPendingMsg: true,
        },
      );

      return res.data.result as Town[];
    } catch (error: any) {
      return false; // Add this line to return undefined in case of an error
    }
  };

  getSilalImages = async (page: number, limit: number) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest(
          'GET',
          `/files/silal/public/recent_images/?page=${page}&per_page=${limit}`,
        ),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
        },
      );

      return res.data as SilalImagesResponse;
    } catch (error: any) {
      return false;
    }
  };

  getSilalFileById = async (file_id: number) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest('GET', `/files/silal/public/${file_id}/`),
        {
          noSuccessMsg: true,
          noPendingMsg: true,
          noFailureMsg: false,
        },
      );

      return res.data.file as ImageType;
    } catch (error: any) {
      return false;
    }
  };

  getSilalTemplateDetailsById = async (template_id: number) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest('GET', `/silal_templates/${template_id}/details/`),
        {
          noSuccessMsg: true,
          noPendingMsg: true,
          noFailureMsg: false,
        },
      );

      return res.data.template as Listing;
    } catch (error: any) {
      return false;
    }
  };
}

const SharedRepository = SharedApiRepository.getInstance(sharedAxiosInstance);
export default SharedRepository;
